<template>

  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->

  <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Profile Home</small></span>
      </div>
    </div>
  </nav>

  <!-- Top -->
  <div id="top"></div>

  <div class="container">
    <div class="row">
      <div class="col s12">

        <LoadingDiv v-if="!isReady" />

        <div v-else>

          <br />

          <div class="section" v-if="enrollee">
            <div class="card z-depth-0" :class="{ 'grey lighten-5': action, white: !action }">
              <!-- Principal -->
              <div class="card-content z-depth-0" :class="{
                'grey lighten-5': displayType == 'a',
                'yellow lighten-5': displayType == 'h',
                'orange lighten-5': currId == enrollee.id && action == 'profile',
                'blue lighten-5':
                  currId == enrollee.id &&
                  (action == 'spouse' || action == 'dependant'),
              }">
                <div class="row">

                  <div class="col s2">
                    <img :src="enrollee.profile_img" width="96" class="circle responsive-img left"
                      v-if="enrollee.profile_img" />
                    <img :src="`https://ui-avatars.com/api/?name=${enrollee.name}&color=FFFFFF&size=128`" width="96"
                      class="circle responsive-img left" v-else />
                  </div>

                  <div class="col s9">
                    <p>{{ enrollee.enrollee_number }}</p>
                    <h5>
                      {{ enrollee.name }}
                      <sup><small><span class="black-text">{{
                        showAgeSex(enrollee.dob, enrollee.sex)
                            }}</span></small></sup> <span v-if="enrollee.status !== 'a'" class="chip red white-text">Inactive</span> 
                    </h5>

                    <!-- Show Dependants (Family only) -->
                    <!-- && !(currId == enrollee.id) -->
                    <template v-if="enrollee.type == 'f'">
                      <span class="clickable" @click="handleShow(enrollee.id)">
                        <small>
                          <span class="chip-more orange-text" v-if="
                            show == enrollee.id &&
                            (enrollee.dependants.length || enrollee.spouse)
                          "><i class="tiny material-icons">close</i> Close</span>
                          <span :class="{
                            'chip-more blue-text':
                              enrollee.dependants.length || enrollee.spouse,
                          }" v-else><span v-if="enrollee.spouse">Spouse, </span><b>{{ enrollee.dependants.length }}</b>
                            Dependant(s)</span>
                        </small>
                      </span>
                    </template>
                  </div>

                  <div class="col s1">
                    <span class="right">
                      <a href="#" class="secondary-content teal-text text-darken-1 dropdown-trigger"
                        :data-target="`dropmenu_${enrollee.id}`"><i class="small material-icons"
                          title="menu">more_vert</i></a>

                      <!-- DropMenu -->
                      <ul :id="`dropmenu_${enrollee.id}`" class="dropdown-content">
                        <!-- <span v-if="!menuMore"> -->

                          <!-- <li v-if="currId == enrollee.id" @click.prevent="
                            handleMenu({ type: 'close', value: enrollee })
                            ">
                            <a href="#">Close Details</a>
                          </li>
                          <li v-else @click.prevent="handleMenu({ type: 'open', value: enrollee })">
                            <a href="#">View Details</a>
                          </li> -->
                          <!-- <li class="divider" tabindex="-1"></li>
                          <li v-if="enrollee.type == 'f' && !enrollee?.spouse && authLevel >= 1" @click.prevent="
                            handleMenu({ type: 'addSpouse', value: enrollee })
                            ">
                            <a href="#">Add Spouse</a>
                          </li> -->
                          <!-- <li class="divider" tabindex="-1"></li>
                          <li v-if="enrollee.type == 'f' && enrollee?.dependants?.length < 4 && authLevel >= 1"
                            @click.prevent="
                              handleMenu({ type: 'addDependant', value: enrollee })
                              ">
                            <a href="#">Add Dependant</a>
                          </li> -->
                          <!-- <li class="divider" tabindex="-1"></li>
                          <li @click.prevent="
                            handleMenu({ type: 'profile', value: enrollee })
                            " v-if="authLevel >= 5">
                            <a href="#">Update Record</a>
                          </li> -->

                        <!-- </span> -->

                        <!-- <span v-else> -->
                          <li @click.prevent="
                            handleMenu({ type: 'provider', value: enrollee })
                            " v-if="authLevel >= 5">
                            <a href="#">Review Provider</a>
                          </li>
                          <!-- <li class="divider" tabindex="-1"></li>
                          <li @click.prevent="handleMenu({ type: 'plan', value: enrollee })" v-if="authLevel >= 5">
                            <a href="#">Review Plan</a>
                          </li> -->
                          <!-- <li class="divider" tabindex="-1"></li>
                          <li @click.prevent="
                            handleMenu({ type: 'status', value: enrollee })
                            " v-if="enrollee.status == 'd' && authLevel >= 5">
                            <a href="#">Restore Principal</a>
                          </li> -->
                          <!-- <li @click.prevent="
                            handleMenu({ type: 'status', value: enrollee })
                            " v-if="enrollee.status != 'd' && authLevel >= 5">
                            <a href="#">De-activate</a>
                          </li> -->

                        <!-- </span> -->

                        <!-- <li class="divider" tabindex="-1"></li>

                        <li @click.prevent="handleMenuMore()" v-if="!menuMore && authLevel >= 5">
                          <span class="teal-text text-darken-2">More &#8250;&#8250;</span>
                        </li>
                        <li @click.prevent="handleMenuMore()" v-if="menuMore && authLevel >= 5">
                          <span class="teal-text text-darken-2">&#8249;&#8249; Back</span>
                        </li> -->
                      </ul>
                    </span>
                  </div>
                </div>

              <!-- Review Provider -->
              <EnrolleeProviderDiv :user="enrollee" @reset="handleReset"
                v-if="action == 'provider' && currId == enrollee.id" />

                <!-- Scheme Details -->
                <!-- <template v-if="showAll == enrollee.id"> -->
                  <div class="card-content spacer10 round">
                    <div class="row blue-grey lighten-5 round">
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Plan Type)</label>
                        <h6><b>{{ enrollee?.plan?.name }}</b></h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Category)</label>
                        <h6 v-if="enrollee.type == 'f'"><b>Family</b></h6>
                        <h6 v-else><b>Individual</b></h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Dependants)</label>
                        <h6 v-if="enrollee.type == 'f'">
                          <b>{{ enrollee.dependants.length }}</b>
                        </h6>
                        <h6 v-else><b>N/A</b></h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Principal Email)</label>
                        <h6 v-if="enrollee.user?.email">
                          {{ enrollee.user?.email }}
                        </h6>
                        <h6 v-else>-</h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Principal Phone)</label>
                        <h6 v-if="enrollee.phone">
                          {{ enrollee.phone }}
                        </h6>
                        <h6 v-else>-</h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Principal Address)</label>
                        <h6 v-if="enrollee?.address">
                          {{ enrollee.address }}
                        </h6>
                        <h6 v-else>-</h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text">(Principal Registered)</label>
                        <h6>
                          {{
                            new Date(enrollee.created_at).toLocaleString(undefined, {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          }}
                        </h6>
                      </div>
                      <div class="col s4 spacer10">
                        <label class="active teal-text"><b>(Current Hospital)</b></label>
                        <h6 v-if="enrollee?.provider?.name">
                          {{ enrollee?.provider?.name }}
                        </h6>
                        <h6 v-else>-</h6>
                      </div>
                      <div class="col s4 spacer10">
                        <br />
                      </div>
                    </div>
                  </div>
                <!-- </template> -->
              </div>

              <!-- Edit Profile -->
              <EnrolleeEditDiv :enrollee="enrollee" @reset="handleReset"
                v-if="action == 'profile' && currId == enrollee.id" />

              <!-- Review Plan -->
              <EnrolleePlanDiv :enrollee="enrollee" @reset="handleReset"
                v-if="action == 'plan' && currId == enrollee.id" />

              <!-- Review Status -->
              <EnrolleeStatusDiv :cat="cat" :enrollee="enrollee" @reset="handleReset"
                v-if="action == 'status' && currId == enrollee.id" />

              <!-- Add Spouse -->
              <AddSpouseDiv :enrollee="enrollee" @reset="handleReset"
                v-if="action == 'spouse' && currId == enrollee.id" />

              <!-- Add Dependant -->
              <AddDependantDiv :enrollee="enrollee" @reset="handleReset"
                v-if="action == 'dependant' && currId == enrollee.id" />

              <!--
              View Spouse
              -->
              <SpouseDiv :authLevel="authLevel" :enrollee="enrollee" @reset="handleReset" @close="handleCloseDependants"
                :close="closeSpouse" v-if="show == enrollee.id || showAll == enrollee.id" />
              <!---->

              <!--
              View Dependant
              -->
              <DependantDiv :authLevel="authLevel" :enrollee="enrollee" @reset="handleReset" @close="handleCloseSpouse"
                :close="closeDependants" v-if="show == enrollee.id || showAll == enrollee.id" />
              <!---->
            </div>
          </div>

          <div class="section center" v-if="!enrollee">
            <h6><img src="@/assets/img/no-user.png" width="256" class="circle responsive-img" /></h6>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUpdated, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import getItemsOfItemsOfItems from "@/composables/getItemsOfItemsOfItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import { ageSex, changeToMoney } from "@/composables/fxLibrary/coreFx";
import EnrolleeStatusDiv from "@/components/client/onboard/EnrolleeStatusEditOnboardComponent.vue";
import EnrolleeProviderDiv from "@/components/client/onboard/EnrolleeProviderOnboardComponent.vue";
import EnrolleePlanDiv from "@/components/client/onboard/EnrolleePlanEditOnboardComponent.vue";
import EnrolleeEditDiv from "@/components/client/onboard/EnrolleeEditOnboardComponent.vue";
import AddSpouseDiv from "@/components/client/onboard/EnrolleeAddSpouseOnboardComponent.vue";
import AddDependantDiv from "@/components/client/onboard/EnrolleeAddDependantOnboardComponent.vue";
import SpouseDiv from "@/components/client/extras/PrincipalSpouseClientComponent.vue";
import DependantDiv from "@/components/client/extras/PrincipalDependantClientComponent.vue";
import M from "materialize-css";

export default {
  name: "profileHome",
  components: {
    LoadingDiv,
    SubHeading,
    EnrolleeStatusDiv,
    EnrolleeProviderDiv,
    EnrolleePlanDiv,
    EnrolleeEditDiv,
    AddSpouseDiv,
    AddDependantDiv,
    SpouseDiv,
    DependantDiv,
  },
  setup(props, context) {
    const displayType = ref("a"); // a, h, d, p
    const authLevel = ref(5); // 1-5
    const response = ref(null);
    const searchTitle = ref(null);
    const isReady = ref(true);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const error = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const searchItem = ref(null);
    const show = ref(null); // spouse && dependants only
    const showAll = ref(null); // detail spouse && dependants
    const menuMore = ref(false);
    const action = ref(null);
    const currId = ref(null);
    const closeSpouse = ref(false);
    const closeDependants = ref(false);

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // client ID
    const principalId = store.state?.user?.account?.id;

    // client ID
    const clientId = store.state?.user?.account?.client_id;

    // user ID
    // add later

    // start
    onMounted(() => {
      // page name
      document.title = "Your Profile";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Your Profile", title: "Home", icon: null, url: "profile", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Home"));
      // set home
      home.value = tabs.value.find(x => x.title.includes("Home"));
    });

    // dropdown
    onMounted(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      M.Dropdown.init(elems, {});
    });

    // dropdown
    onUpdated(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      M.Dropdown.init(elems, {});
    });

     // start
    onMounted(() => {
      // page name
      getAllUser();
    });

    // prinipals
    const getAllUser = () => {
      // set current Url
      currUrl.value = "principal/client/enrollee/search";
      // set current Hook
      currHook.value = "?";
      // get items from function
      // getSearchItemsFromApi(currUrl.value, `${props.clientId}?z=${val}`);
      getSearchItemsFromApi(currUrl.value, clientId, principalId);
    };

    // get function
    const getSearchItemsFromApi = (table, id1, id2) => {
      (async () => {
        const { res, err } = await getItemsOfItemsOfItems(table, id1, id2);

        if (res.value) {
          response.value = res.value.data;
          // open details
          currId.value = response.value?.id;
          showAll.value = response.value?.id;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // to naira
    const changeToNaira = (premiums, type) => {
      // sort value
      let val;
      premiums.forEach((x) => {
        if (x.type == type && !val) {
          val = x.amount;
        }
      });
      const { fx } = changeToMoney(val);
      return fx.value;
    };

    // to naira
    const changeToNairaTotal = (val) => {
      const { fx } = changeToMoney(val);
      return fx.value;
    };

    // shore more in Menu
    const handleMenuMore = () => {
      menuMore.value = !menuMore.value;
    };

    // clear all
    const clearAll = () => {
      // clear
      show.value = null;
      showAll.value = null;
      action.value = null;
      currId.value = null;
    };

    // handle show
    const handleShow = (val) => {
      // same or not
      let checker = false;
      if (val == show.value) {
        checker = true;
      }

      // clear first
      clearAll();

      // reset
      if (!checker) {
        show.value = val;
      }
    };

    // handle menu
    const handleMenu = (val) => {
      if (val.type == "close") {
        // clear
        clearAll();
      }

      if (val.type == "open") {
        // clear
        clearAll();
        // show && showAll
        showAll.value = val.value.id;
        show.value = val.value.id;
        currId.value = val.value.id;
      }

      if (val.type == "addSpouse") {
        // clear
        clearAll();
        // reset
        action.value = "spouse";
        currId.value = val.value.id;
        show.value = val.value.id;
      }

      if (val.type == "addDependant") {
        // clear
        clearAll();
        // reset
        action.value = "dependant";
        currId.value = val.value.id;
        show.value = val.value.id;
      }

      if (val.type == "profile") {
        // clear
        clearAll();
        // reset
        action.value = "profile";
        currId.value = val.value.id;
      }

      if (val.type == "provider") {
        // clear
        clearAll();
        // reset
        action.value = "provider";
        currId.value = val.value.id;
      }

      if (val.type == "plan") {
        // clear
        clearAll();
        // reset
        action.value = "plan";
        currId.value = val.value.id;
      }

      if (val.type == "status") {
        // clear
        clearAll();
        // reset
        action.value = "status";
        currId.value = val.value.id;
      }
    };

    // handle spouse
    const handleCloseSpouse = (val) => {
      // close
      if (val) {
        closeSpouse.value = true;
      }
      // null caller
      closeDependants.value = false;
    };

    // handle dependants
    const handleCloseDependants = (val) => {
      // close
      if (val) {
        closeDependants.value = true;
      }
      // null caller
      closeSpouse.value = false;
    };

    // handle
    const handleReset = (val) => {
      // send back
      context.emit("reset", val);
      // clear first
      clearAll();
    };

    // restart
    const handleClearSearch = () => {
      // start laoding
      isLoading.value = true;
      // null search
      searchItem.value = null;
    };

    // output results
    const enrollee = computed(() => {
      if (!response.value) {
        return [];
      } else {
        console.log(response.value);
        return response.value;
      }
    });


    return {
      handleReset,
      handleCloseSpouse,
      handleCloseDependants,
      handleMenuMore,
      handleMenu,
      handleShow,
      changeToNaira,
      changeToNairaTotal,
      ageSex,
      handleClearSearch,
      showAgeSex,
      handleActive,
      authLevel,
      displayType,
      closeSpouse,
      closeDependants,
      isSubmitting,
      isReady,
      isLoading,
      error,
      menuMore,
      show,
      showAll,
      action,
      currId,
      home,
      currTab,
      tabs,
      searchItem,
      searchTitle,
      enrollee,
    };
  },
};
</script>

<style scoped>
.top-card {
  background-color: #163f53;
}

.top-card-light {
  background-color: #254657;
}

.top-card-dark {
  background-color: #163f53;
}

.line {
  margin-top: -45px;
}

.progress {
  margin-top: -15px;
}

.pointer {
  cursor: default;
}

/* base class */
.tab-custom {
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  color: #bbb;
  border: 1px solid transparent;
}

.tab-custom:hover {
  color: #000000 !important;
}

/* Removed
color: #000000;
border: 1px solid #ddd;
background-color: #d1f3df; */
.tab-custom-active {
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  border-bottom: 2px solid orange;
}

/* display */
.tab-custom-section {
  padding: 20px 0 0;
  border-top: 1px solid #ddd;
}

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}
</style>
